import { getCompany } from './get-company';
import { getGalleryPage } from './get-gallery-page';
import { getHomePage } from './get-home-page';

export const SanityCMSService = {
    getCompany,
    getGalleryPage,
    getHomePage,
};
